import { Sparkles } from "lucide-react";

export const RoadmapFeatureCard = () => (
  <section className="section-shell pt-4" data-testid="roadmap-feature-card-shell">
    <div className="rounded-[28px] border border-[#D4AF37]/18 bg-[linear-gradient(135deg,#fffaf1_0%,#f4ead6_55%,#eadbb8_100%)] px-6 py-5 shadow-[0_18px_50px_rgba(0,25,53,0.08)] md:px-8" data-testid="roadmap-feature-card">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-4">
          <div className="rounded-full border border-[#D4AF37]/30 bg-white/85 p-3 text-[#8b6d16]" data-testid="roadmap-feature-card-icon">
            <Sparkles className="h-5 w-5" />
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8b6d16]" data-testid="roadmap-feature-card-kicker">Roadmap Active</p>
            <h3 className="mt-2 text-2xl font-semibold text-[#001935]" data-testid="roadmap-feature-card-heading">AI Virtual Staging (Beta)</h3>
            <p className="mt-2 text-sm leading-7 text-[#42566f]" data-testid="roadmap-feature-card-copy">Coming Soon — this feature is now surfaced across the SG Prop Portal experience as an active roadmap item.</p>
          </div>
        </div>
        <div className="inline-flex items-center self-start rounded-full border border-[#D4AF37]/30 bg-white px-4 py-2 text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="roadmap-feature-card-status-pill">
          Coming Soon
        </div>
      </div>
    </div>
  </section>
);